// 初始玩家数据
export const INITIAL_PLAYERS = [
  { name: '杨', number: 1 },
  { name: '刁', number: 2 },
  { name: '张', number: 3 },
  { name: '李', number: 4 },
  { name: '谢', number: 5 },
];

// 比赛结果选项
export const MATCH_RESULTS = {
  WIN: 'win' as const,
  DRAW: 'draw' as const,
  LOSS: 'loss' as const,
};

// 比赛结果标签
export const MATCH_RESULT_LABELS = {
  [MATCH_RESULTS.WIN]: '胜利',
  [MATCH_RESULTS.DRAW]: '平局',
  [MATCH_RESULTS.LOSS]: '失败',
};

// 最小参赛人数
export const MIN_PLAYERS_FOR_MATCH = 4;